import { WallSide } from '../enums/wallSide.enum';
import { FinishTypes } from '../enums/finishTypes.enum';

export class WallFinishUpdate {
  wallSide: WallSide;
  finishType: FinishTypes;
  exterior: boolean;
  innerWallId: string;

  constructor(wallSide: WallSide, finishType: FinishTypes, exterior: boolean, innerWallId?: string) {
    this.wallSide = wallSide;
    this.finishType = finishType;
    this.exterior = exterior;
    this.innerWallId = innerWallId;
  }
}
